import http from './http'

export default class CertifyApi{
	// 新增文章
	static addSiteArticle(data) {
		return http.httpPost('/artice/add', data)
	}
	// 发布文章
	static publishSiteArticle(data) {
		return http.httpPost('/artice/publish', data)
	}
	// 修改文章
	static editSiteArticle(data) {
		return http.httpPut('/artice/edit', data)
	}
    // 删除文章
    static deleteSiteArticle(id) {
        return http.httpDelete('/artice/remove/' + id)
    }
    // 获取文章列表
    static getSiteArticleDetail(params) {
        return http.httpGet('/artice/list', params)
    }
    // 获取文章详情
    static getDetail(id) {
        return http.httpGet('/artice/' + id)
    }
    // 获取网站列表
    static getSiteList(params) {
        return http.httpGet('edit/getWebsitesCategories', params)
    }
}
